<template>
    <div class="flex py-2">
        <h3 class="pr-2">Payment Amount:</h3>
        <p>€{{ appendDecimal(depositAmount?.toString(), true) }}</p>
    </div>
    <div class="border-2 border-grey-200 rounded-[3px] w-full transform-container overflow-hidden">
        <div class="transform-wrapper">
            <iframe id="payment-frame" class="w-full h-[610px]" title="Secure payment form" :src="iframeUrl ?? ''" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useProposalStore } from "@/stores/risk/risk";
import { appendDecimal } from "@mbs-npm/anpost-ui";

const proposalStore = useProposalStore();

const iframeUrl = computed(() => proposalStore.payment.url);
const depositAmount = computed(() => proposalStore.proposal.quote.monthly_deposit);
</script>

<style scoped>
@media (max-width: 511px) {
    .transform-container {
        height: 457.5px; /* 75% of 610px */
    }

    .transform-wrapper {
        transform: scale(0.75);
        transform-origin: top left;
        width: 133%;
        height: 610px;
    }
}

@media (min-width: 512px) {
    .transform-container {
        height: 610px;
    }

    .transform-wrapper {
        width: 100%;
        height: 610px;
    }
}

@media (min-width: 640px) and (max-width: 827px) {
    .transform-container {
        height: 457.5px; /* 75% of 610px */
    }

    .transform-wrapper {
        transform: scale(0.75);
        transform-origin: top left;
        width: 133%;
        height: 610px;
    }
}

@media (min-width: 828px) {
    .transform-container {
        height: 610px;
    }

    .transform-wrapper {
        width: 100%;
        height: 610px;
    }
}
</style>
